var _defs, _rect, _circle, _circle2, _circle3, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fef2d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#e2f4f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#cbeee8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 140,
    r: 90,
    fill: "#f59e0b",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 140,
    r: 110,
    fill: "#0f766e",
    opacity: 0.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 460,
    r: 140,
    fill: "#0f766e",
    opacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 220,
    width: 260,
    height: 280,
    rx: 24,
    fill: "#ffffff",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 190,
    width: 340,
    height: 320,
    rx: 28,
    fill: "#ffffff",
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 260h160",
    stroke: "#0f766e",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 300h140",
    stroke: "#f59e0b",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M470 250h220",
    stroke: "#0f766e",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M470 300h180",
    stroke: "#f59e0b",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M470 350h200",
    stroke: "#0f766e",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 430,
    r: 36,
    fill: "#f59e0b",
    opacity: 0.55
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 430,
    r: 36,
    fill: "#0f766e",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner1);
export default __webpack_public_path__ + "static/media/banner-1.a6ac1ccc84fe555a3cd7fc7d21f675a8.svg";
export { ForwardRef as ReactComponent };